import { CARD_TYPES } from "layouts/Payment/common/dependencies/constants";
import { DEVICE_TYPE, platformNames } from "shared/constants/index";


export const AMEX_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/AMEX.svg";
export const DINERS_CLUB_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/1.png";
export const DISCOVER_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/2.png";
export const JCB_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/4.png";
export const LASER_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/5.png";
export const MAESTRO_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Maestro.svg";
export const MASTERCARD_ICON =
  "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/mastercard.svg";
export const RUPAY_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/Rupay.svg";
export const VISA_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/VISA.svg";
export const WESTERN_UNION_ICON =
  "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/10.png";
export const PAYPAL_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cards/7.png";

export const CARD_TYPE_ICONS = {
  [CARD_TYPES.AMEX]: AMEX_ICON,
  [CARD_TYPES.DINERS]: DINERS_CLUB_ICON,
  [CARD_TYPES.DISCOVER]: DISCOVER_ICON,
  [CARD_TYPES.JCB]: JCB_ICON,
  [CARD_TYPES.LASER]: LASER_ICON,
  [CARD_TYPES.MAESTRO]: MAESTRO_ICON,
  [CARD_TYPES.SBIMAESTRO]: MAESTRO_ICON,
  [CARD_TYPES.MASTERCARD]: MASTERCARD_ICON,
  [CARD_TYPES.RUPAY]: RUPAY_ICON,
  [CARD_TYPES.VISA]: VISA_ICON,
  [CARD_TYPES.WESTERN_UNION_ICON]: WESTERN_UNION_ICON,
  [CARD_TYPES.PAYPAL_ICON]: PAYPAL_ICON,
  [CARD_TYPES.INVALID]: "",
};

export const STATIC_CARD_IMAGES = [VISA_ICON, MASTERCARD_ICON, RUPAY_ICON, AMEX_ICON];

export const ICONS = {
  CHECKBOX_ACTIVE:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Checkbox%20-%20Icon%20Only.svg",
  ARROW_DOWN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/down.svg",
  ARROW_UP: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Up.svg",
  ARROW_RIGHT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
  CONTINUE_SHOPPING_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
  DROPDOWN_DOWN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DownDropdown.svg",
  DRAG: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Handle.svg",
  CLEAR: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Clear.svg",
  ZEST_MONEY: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/ZestMoney.svg",
  SIMPL: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Zest_Simpl/Simpl.svg",
  CHECKBOX_ACTIVE_MEN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Checkbox-Icon.svg",
  TICK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/pink_tick.svg",
  TICK_ICON_MEN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Toggle.svg",
  ACTION_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/arrow-right-12.svg",
  ACTION_ICON_MEN: "https://adn-static1.nykaa.com/media/BNPL/arrow-right.svg",
  CARD_NOT_SECURED:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_alert_40x40%20copy.svg",
  UPGRADED_PAYMENT_SECURITY:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Protect_40x40.svg",
  CARD_NUMBER_DETAILS:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Edit_40x40%20copy.svg",
  CARD_NOT_SECURED_MEN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_alert_40x40.svg",
  UPGRADED_PAYMENT_SECURITY_MEN:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Protect_man.svg",
  CARD_NUMBER_DETAILS_MEN:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Edit_40x40.svg",
  CARD_NOT_SECURED_FASHION:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_alert_fashion.svg",
  UPGRADED_PAYMENT_SECURITY_FASHION:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Protect_fashion.svg",
  CARD_NUMBER_DETAILS_FASHION:
    "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Edit_fashion.svg",
  NYKAA_WALLET: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/NykaaWallet.svg",
  SUCCESS_TICK: "https://images-static.nykaa.com/media/wysiwyg/Payments/SuccessTick.svg"
};

export enum ICONS_NAMES {
  CARD_NOT_SECURED = "CARD_NOT_SECURED",
  UPGRADED_PAYMENT_SECURITY = "UPGRADED_PAYMENT_SECURITY",
  CARD_NUMBER_DETAILS = "CARD_NUMBER_DETAILS",
  REWARD_POINT_ICON = "REWARD_POINT_ICON",
  PRICE_DETAIL_ICON = "PRICE_DETAIL_ICON",
  BUYERS_ASSURANCE_ICON = "BUYERS_ASSURANCE_ICON",
  RADIO = "RADIO",
  ARROW_DOWN = "ARROW_DOWN",
  ARROW_LEFT="ARROW_LEFT",
  CIRCULAR_RADIO_CHECK = "CIRCULAR_RADIO_CHECK",
  ARROW_UP = "ARROW_UP",
  CREDIT_CARD = "CREDIT_CARD",
  CVV = "CVV",
  COD = "COD",
  EMI = "EMI",
  GIFT_CARD = "GIFT_CARD",
  ALERT = "ALERT",
  ALERT_NEGETIVE = "ALERT_NEGETIVE",
  GOOGLE_PAY = "GOOGLE_PAY",
  NETBANKING = "NETBANKING",
  DRAG = "DRAG",
  PAYTM = "PAYTM",
  ALERT_SIMPL = "ALERT_SIMPL",
  RADIO_ACTIVE = "RADIO_ACTIVE",
  UPI_ACTIVE = "UPI_ACTIVE",
  RADIO_ICON_SELECTED = "RADIO_ICON_SELECTED",
  SNPL = "SNPL",
  CLEAR = "CLEAR",
  ADDRESS_CLEAR = "ADDRESS_CLEAR",
  CLEAR_WHITE = "CLEAR_WHITE",
  SAVED_ZEST_MONEY = "SAVED_ZEST_MONEY",
  PHONE_PE = "PHONE_PE",
  UPI_PAYTM = "UPI_PAYTM",
  OTHER_UPI = "OTHER_UPI",
  UPI = "UPI",
  DROPDOWN_DOWN = "DROPDOWN_DOWN",
  INFO_ICON = "INFO_ICON",
  CHECKBOX = "CHECKBOX",
  SAVED_PAYTM = "SAVED_PAYTM",
  CHECKBOX_ACTIVE = "CHECKBOX_ACTIVE",
  SUCCESS_ICON = "SUCCESS_ICON",
  SIMPL = "SIMPL",
  OTHER_BANK = "OTHER_BANK",
  ACTION_ICON = "ACTION_ICON",
  ARROW_RIGHT = "ARROW_RIGHT",
  WALLET_DISCOUNT_ALERT = "WALLET_DISCOUNT_ALERT",
  DELETE_ICON = "DELETE_ICON",
  ADD_ADDRESS_ICON = "ADD_ADDRESS_ICON",
  WARN_ICON = "WARN_ICON",
  CVV_INFO = "CVV_INFO",
  APPICON = "APPICON",
  NOTIFYICON = "NOTIFYICON",
  COMPLETEICON = "COMPLETEICON",
  AXIS = "AXIS",
  HDFC = "HDFC",
  ICICI = "ICICI",
  KOTAK = "KOTAK",
  SBI = "SBI",
  YES_BANK = "YES_BANK",
  ARROW_SOLID = "ARROW_SOLID",
  PREFFERED_PAYMENT = "PREFFERED_PAYMENT",
  HEADER_LOGO = "HEADER_LOGO",
  HEADER_EDIT = "HEADER_EDIT",
  HEADER_TICK = "HEADER_TICK",
  HEADER_NUMBER_2 = "HEADER_NUMBER_2",
  HEADER_NUMBER_3 = "HEADER_NUMBER_3",
  PAYMENT_HEADER_BACKGROUND = "PAYMENT_HEADER_BACKGROUND",
  WALLET_DISCOUNT = "WALLET_DISCOUNT",
  ALERT_INFO = "ALERT_INFO",
  CHEVRON = "CHEVRON",
  DROPHANDLE = "DROPHANDLE",
  ALL_UPI_PROFILE_PHONEPE = "ALL_UPI_PROFILE_PHONEPE",
  ALL_UPI_PROFILE_GOOGLEPAY = "ALL_UPI_PROFILE_GOOGLEPAY",
  ALL_UPI_PROFILE = "ALL_UPI_PROFILE",
  ALL_FIND_UPI_ID_PHONEPE = "ALL_FIND_UPI_ID_PHONEPE",
  ALL_FIND_UPI_ID_GOOGLEPAY = "ALL_FIND_UPI_ID_GOOGLEPAY",
  ALL_FIND_UPI_ID = "ALL_FIND_UPI_ID",
  CRED_PAY = "CRED_PAY",
  AUTH_CARD = "AUTH_CARD",
  AUTH_CARD_SIGN_UP = "AUTH_CARD_SIGN_UP",
  AUTH_CARD_GUEST = "AUTH_CARD_GUEST",
  PAGE_TITLE_AUTH = "PAGE_TITLE_AUTH",
  BACK_ICON = "BACK_ICON",
  SUCCESS_ICON_GIFTCARD = "SUCCESS_ICON_GIFTCARD",
  MAIL_ICON = "MAIL_ICON",
  MOBILE_ICON = "MOBILE_ICON",
  SUCCESS_INFO = "SUCCESS_INFO",
  AUTO_DETECT = "AUTO_DETECT",
  DELIVERY_TRUCK = "DELIVERY_TRUCK",
  ALERT_ICON = "ALERT_ICON",
  WALLET_LOGO = "WALLET_LOGO",
  BRAND_LOGO = "BRAND_LOGO",
  DESKTOP_PAGE_TITLE_ADDRESS_IMAGE = "DESKTOP_PAGE_TITLE_ADDRESS_IMAGE",
  EDD_INFO_ICON = "EDD_INFO_ICON",
  TICK_ICON = "TICK_ICON",
  TICK_ICON_NEW = "TICK_ICON_NEW",
  DELIVERY_VAN_ICON = "DELIVERY_VAN_ICON",
  ZEST_MONEY = "ZEST_MONEY",
  OTHER_PAYMENT_ICON = "OTHER_PAYMENT_ICON",
  RIGHT_ARROW = "RIGHT_ARROW",
  ADDRESS_BACKFRICTION_LEADING_ICON = "ADDRESS_BACKFRICTION_LEADING_ICON",
  MAPS_BACKGROUND = "MAPS_BACKGROUND",
  PRIVACY_ICON = "PRIVACY_ICON",
  OOS_BANNER = "OOS_BANNER",
  ERROR_BANNER = "ERROR_BANNER",
  NYKAA_WALLET = "NYKAA_WALLET",
  OOS_ICON = "OOS_ICON",
  SERVER_ERROR_ICON = "SERVER_ERROR_ICON",
  FAIL_ICON = "FAIL_ICON",
  RIGHT_CHEVRON = "RIGHT_CHEVRON",
  NEW_LOCATOR = "NEW_LOCATOR",
  NEW_COD = "NEW_COD",
  DETECT_LOCATION = "DETECT_LOCATION",
  PRIMARY_RIGHT_ARROW = "PRIMARY_RIGHT_ARROW",
  DEFAULT_QR = "DEFAULT_QR",
  UPI_PAYMENTS = "UPI_PAYMENTS",
  STAR_ICON = "STAR_ICON",
  MONEY_COIN = "MONEY_COIN",
  INSTANT_ICON = "INSTANT_ICON",
  AUTO_DETECT_BANNER = "AUTO_DETECT_BANNER",
  PHONE = "PHONE",
  CUSTOMER_SUPPORT = "CUSTOMER_SUPPORT",
  CLEAR_LIGHT = "CLEAR_LIGHT",
  CARD_LARGE_ICON = "CARD_LARGE_ICON",
  CASH_LARGE_ICON = "CASH_LARGE_ICON",
  UNIVERSAL_PAYMENT_ICON = "UNIVERSAL_PAYMENT_ICON",
  UPI_LARGE_ICON = "UPI_LARGE_ICON",
  EMI_INFO_ICON = "EMI_INFO_ICON",
  EMI_ALERT = "EMI_ALERT",
  ORDER_CONFIRMED_ICON="ORDER_CONFIRMED_ICON",
  CONTINUE_SHOPPING_ICON="CONTINUE_SHOPPING_ICON",
  HELP_END_ICON = "HELP_END_ICON",
  EMAIL = "EMAIL",
  DIAL = "DIAL",
  STREET_VIEW = "STREET_VIEW",
}
/**
 * add all icons here only
 */
const ALL_ICONS: any = {
  FOOTLOCKER: {
    AUTO_DETECT_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/AutoDetectBannerFashion.svg",
    CARD_NOT_SECURED:
      "https://images-static.nykaa.com/media/desktop-icons/Card_alert_FL.svg",
    UPGRADED_PAYMENT_SECURITY:
      "https://images-static.nykaa.com/media/desktop-icons/Card_Protect_FL.svg",
    CARD_NUMBER_DETAILS:
      "https://images-static.nykaa.com/media/desktop-icons/Card_Edit_FL.svg",
    BUYERS_ASSURANCE_ICON:
      "https://images-static.nykaa.com/media/desktop-icons/Card_Lock_footlocker.svg",
    CIRCULAR_RADIO_CHECK:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Radio-Icon%20Only.svg",
    RADIO_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/enabled_active.svg",
    UPI_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/enabled_active.svg",
    CHECKBOX_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Checkbox-Icon%20Only.svg",
    WALLET_DISCOUNT_ALERT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Wallet_Discount_Alert_Fashion.svg",
    ADD_ADDRESS_ICON:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/plus-24.svg",
    CVV_INFO: "https://images-static.nykaa.com/media/wysiwyg/Payments/cvv_beauty.svg",
    ACTION_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-icon.svg",
    HEADER_LOGO:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/nykaa-logo.svg",
    HEADER_EDIT:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/addressFashion.svg",
    HEADER_TICK:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/signUpTick.svg",
    PAYMENT_HEADER_BACKGROUND:
      "https://images-static.nykaa.com/media/desktop-icons/payment_FootLocker.svg",
    WALLET_DISCOUNT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Wallet_Discount_fashion.svg",
    AUTH_CARD:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/haveAAccount.svg",
    AUTH_CARD_SIGN_UP:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/newToNykaa.svg",
    AUTH_CARD_GUEST: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth2.svg",
    PAGE_TITLE_AUTH:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/fashion_bag%202.svg",
    RADIO_ICON_SELECTED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion-Radio-Icon-Selected.svg",
    AUTO_DETECT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/AutoDetectMan.svg",
    BRAND_LOGO: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/fashion-logo.svg",
    DESKTOP_PAGE_TITLE_ADDRESS_IMAGE:
      "https://images-static.nykaa.com/media/desktop-icons/addressHeader_FL.svg",
    TICK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Toggle.svg",
    RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/arrow-right-fashion.svg",
    TICK_ICON_NEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/tick-fashion.svg",
    ADDRESS_BACKFRICTION_LEADING_ICON: "https://images-static.nykaa.com/media/desktop-icons/Vector_fashion.svg",
    RIGHT_CHEVRON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-fashion.svg",
    EMI_INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/InfoIcon.svg",
    EMI_ALERT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert.svg",
  },
  FASHION: {
    AUTO_DETECT_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/AutoDetectBannerFashion.svg",
    CARD_NOT_SECURED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_alert_fashion.svg",
    UPGRADED_PAYMENT_SECURITY:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Protect_fashion.svg",
    CARD_NUMBER_DETAILS:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Edit_fashion.svg",
    BUYERS_ASSURANCE_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Lock_fashion.svg",
    CIRCULAR_RADIO_CHECK:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Radio-Icon%20Only.svg",
    RADIO_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/enabled_active.svg",
    UPI_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/enabled_active.svg",
    CHECKBOX_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Checkbox-Icon%20Only.svg",
    WALLET_DISCOUNT_ALERT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Wallet_Discount_Alert_Fashion.svg",
    ADD_ADDRESS_ICON:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/plus-24.svg",
    CVV_INFO: "https://images-static.nykaa.com/media/wysiwyg/Payments/cvv_beauty.svg",
    ACTION_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-icon.svg",
    HEADER_LOGO:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/nykaa-logo.svg",
    HEADER_EDIT:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/addressFashion.svg",
    HEADER_TICK:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/signUpTick.svg",
    PAYMENT_HEADER_BACKGROUND:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/paymentHeader.svg",
    WALLET_DISCOUNT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Wallet_Discount_fashion.svg",
    AUTH_CARD:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/haveAAccount.svg",
    AUTH_CARD_SIGN_UP:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/newToNykaa.svg",
    AUTH_CARD_GUEST: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth2.svg",
    PAGE_TITLE_AUTH:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/fashion_bag%202.svg",
    RADIO_ICON_SELECTED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion-Radio-Icon-Selected.svg",
    AUTO_DETECT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/AutoDetectMan.svg",
    BRAND_LOGO: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/fashion-logo.svg",
    DESKTOP_PAGE_TITLE_ADDRESS_IMAGE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/addressHeader.svg",
    TICK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Toggle.svg",
    RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/arrow-right-fashion.svg",
    ADDRESS_BACKFRICTION_LEADING_ICON:
      "https://images-static.nykaa.com/media/desktop-icons/Vector_fashion.svg",
    MAPS_BACKGROUND: "https://images-static.nykaa.com/media/wysiwyg/Payments/FashionStreet.png",
    PRIVACY_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion-vendor.svg",
    DELIVERY_TRUCK: "https://images-static.nykaa.com/media/wysiwyg/Payments/DeliveryTruck.svg",
    ALERT_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/AlertWarning.svg",
    RIGHT_CHEVRON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-fashion.svg",
    TICK_ICON_NEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/tick-fashion.svg",
    DETECT_LOCATION: "https://images-static.nykaa.com/media/wysiwyg/Payments/LocateIconFashion.svg",
    PRIMARY_RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/RignhtArrowFashion.svg",
    EMI_INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/InfoIcon.svg",
    EMI_ALERT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert.svg",
  },
  NYKAA: {
    AUTO_DETECT_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/AutoDetectBannerBeauty.svg",
    ACTION_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-icon.svg",
    CARD_NOT_SECURED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_alert_40x40%20copy.svg",
    UPGRADED_PAYMENT_SECURITY:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Protect_40x40.svg",
    CARD_NUMBER_DETAILS:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Edit_40x40%20copy.svg",
    REWARD_POINT_ICON: "",
    PRICE_DETAIL_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/ic_payment_details-03.svg",
    BUYERS_ASSURANCE_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/BuyerAssurance.svg",
    RADIO: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio_List_Icon.svg",
    ARROW_DOWN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/down.svg",
    CIRCULAR_RADIO_CHECK:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/Radio-Icon_Only.svg",
    ARROW_UP: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Up.svg",
    CREDIT_CARD:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/card-debit-credit-24_2.svg",
    CVV: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cvv-01%201.svg",
    COD: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/COD.svg",
    EMI: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/EMI.svg",
    GIFT_CARD: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/GiftCard.svg",
    ALERT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert.svg",
    ALERT_NEGETIVE: "https://images-static.nykaa.com/media/wysiwyg/Payments/alert-negative.svg",
    GOOGLE_PAY: "https://images-static.nykaa.com/media/desktop-icons/googlePay.svg",
    NETBANKING: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/NetBanking.svg",
    DRAG: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Handle.svg",
    PAYTM: "https://images-static.nykaa.com/media/desktop-icons/paytm.svg",
    ALERT_SIMPL:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/alert-negative-filled-20.svg",
    RADIO_ACTIVE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio_List_Icon_Checked.svg",
     UPI_ACTIVE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio_List_Icon_Checked.svg",
    SNPL: "https://adn-static1.nykaa.com/media/BNPL/snpl.svg",
    CLEAR: "https://images-static.nykaa.com/media/wysiwyg/Payments/circle-x-duotone.svg",
    SAVED_ZEST_MONEY: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Zest_Simpl/Zest.svg",
    PHONE_PE: "https://images-static.nykaa.com/media/desktop-icons/phonePe.svg",
    UPI_PAYTM: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/UPImWeb/Paytm.svg",
    OTHER_UPI: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/UPImWeb/UPI-Logo-vector 1.svg",
    UPI: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/UPImWeb/UPI-Logo-vector%201.svg",
    DROPDOWN_DOWN: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DownDropdown.svg",
    INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/InfoIcon.svg",
    CHECKBOX:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Checkbox%20-%20Icon%20OnlyUnselected.svg",
    SAVED_PAYTM: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/paytm2x.png",
    CHECKBOX_ACTIVE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Checkbox%20-%20Icon%20Only.svg",
    SUCCESS_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/3Success.svg",
    SIMPL: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Zest_Simpl/Simpl.svg",
    OTHER_BANK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7Otherbank.svg",
    ARROW_RIGHT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
    CONTINUE_SHOPPING_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
    WALLET_DISCOUNT_ALERT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Wallet_Discount_Alert_Beauty.svg",
    DELETE_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Chevron.svg",
    ADD_ADDRESS_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/plus-icon.svg",
    WARN_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/warningIcon.svg",
    CVV_INFO: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/cvv-info-beauty-new.svg",
    ADDRESS_CLEAR: "https://images-static.nykaa.com/media/wysiwyg/Payments/addressCrossIcon.svg",
    CLEAR_WHITE: "https://images-static.nykaa.com/fashion-images/media/wysiwyg/Payments/circle-x-duotone-white.svg",
    APPICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/TimerScreen/UPI.svg",
    NOTIFYICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/bell2x.png",
    COMPLETEICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/tick2x.png",
    AXIS: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7AXIS.svg",
    HDFC: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7HDFC.svg",
    ICICI: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7ICICI.svg",
    KOTAK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7KOTAK.svg",
    SBI: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7SBI.svg",
    YES_BANK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/7YES.svg",
    ARROW_SOLID:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/dropdown-right-arrow.png",
    PREFFERED_PAYMENT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/PreferredPayment.svg",
    HEADER_LOGO:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/nykaa-logo.svg",
    HEADER_EDIT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/edit-icon.svg",
    HEADER_TICK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/tick-icon.svg",
    HEADER_NUMBER_2:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/step-2-icon.svg",
    HEADER_NUMBER_3:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/step-3-icon.svg",
    PAYMENT_HEADER_BACKGROUND:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/Illus_3.svg",
    WALLET_DISCOUNT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/Wallet_Discount_48x48.svg",
    ALERT_INFO: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert-info-filled-20.svg",
    CHEVRON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/back-chevron-icon.svg",
    DROPHANDLE: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Handle.svg",
    ALL_UPI_PROFILE_PHONEPE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/phonePeProfile.png",
    ALL_UPI_PROFILE_GOOGLEPAY:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/googlePayProfile.png",
    ALL_UPI_PROFILE: "https://images-static.nykaa.com/media/desktop-icons/upi_placeholder_1.svg",
    ALL_FIND_UPI_ID_PHONEPE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/phonePeUpiId.png",
    ALL_FIND_UPI_ID_GOOGLEPAY:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/googlePayUpiId.png",
    ALL_FIND_UPI_ID: "https://images-static.nykaa.com/media/desktop-icons/upi_placeholder_2.svg",
    CRED_PAY: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/credPayIcon.svg",
    AUTH_CARD: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth1.svg",
    AUTH_CARD_SIGN_UP:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth3.svg",
    AUTH_CARD_GUEST: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth2.svg",
    PAGE_TITLE_AUTH:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/header-auth.svg",
    BACK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/1Arrow_back.svg",
    RADIO_ICON_SELECTED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio-Icon-Selected.svg",
    MAIL_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/giftcard_icons/mail.svg",
    MOBILE_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/giftcard_icons/mobile.svg",
    SUCCESS_ICON_GIFTCARD:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/giftcard_icons/success-positive-48.svg",
    SUCCESS_INFO:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/success-alert.svg",
    AUTO_DETECT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/AutoDetect.svg",
    WALLET_LOGO: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/NykaaWallet.svg",
    DESKTOP_PAGE_TITLE_ADDRESS_IMAGE:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/header-address.svg",
    EDD_INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/3Info.svg",
    TICK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/pink_tick.svg",
    DELIVERY_VAN_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Delivery_Van.svg",
    ZEST_MONEY: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/ZestMoney.svg",
    OTHER_PAYMENT_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Other_Payment_Icon.svg",
    RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/arrow-right-beauty.svg",
    ADDRESS_BACKFRICTION_LEADING_ICON:
      "https://images-static.nykaa.com/media/desktop-icons/Vector.svg",
    MAPS_BACKGROUND: "https://images-static.nykaa.com/media/wysiwyg/Payments/BeautyStreet.png",
    PRIVACY_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Vendor.svg",
    DELIVERY_TRUCK: "https://images-static.nykaa.com/media/wysiwyg/Payments/DeliveryTruck.svg",
    ALERT_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/AlertWarning.svg",
    OOS_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/OutOfStackError.svg",
    ERROR_BANNER:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/SomethingWrongError(1).svg",
    NYKAA_WALLET: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/NykaaWallet.svg",
    OOS_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/ProductOutOfstock.svg",
    SERVER_ERROR_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/ServerDownError.svg",
    FAIL_ICON: "https://images-static.nykaa.com/media/desktop-icons/fail-icon.svg",
    RIGHT_CHEVRON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right.svg",
    NEW_LOCATOR: "https://images-static.nykaa.com/media/wysiwyg/Payments/locator-new.svg",
    NEW_COD: "https://images-static.nykaa.com/media/wysiwyg/Payments/cod-new.svg",
    DETECT_LOCATION: "https://images-static.nykaa.com/media/wysiwyg/Payments/LocateIconBeauty.svg",
    PRIMARY_RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/RightArrowBeauty.svg",
    DEFAULT_QR: "https://images-static.nykaa.com/media/wysiwyg/Payments/default-qr-code.png",
    UPI_PAYMENTS: "https://images-static.nykaa.com/media/wysiwyg/Payments/upi-payment-icon1.svg",
    TICK_ICON_NEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/tick-beauty.svg",
    STAR_ICON: "https://images-static.nykaa.com/media/desktop-icons/star.svg",
    MONEY_COIN: "https://images-static.nykaa.com/media/desktop-icons/Money_Coin.svg",
    INSTANT_ICON: "https://images-static.nykaa.com/media/desktop-icons/InstantTag.svg",
    PHONE: "https://images-static.nykaa.com/media/wysiwyg/Payments/phone.svg",
    CUSTOMER_SUPPORT: "https://images-static.nykaa.com/media/wysiwyg/Payments/customer-support.svg",
    CLEAR_LIGHT: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/circle-duotone-light.svg",
    CARD_LARGE_ICON: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/CardLargeIcon.svg",
    CASH_LARGE_ICON: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/CashLargeIcon.svg",
    UNIVERSAL_PAYMENT_ICON: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/UniversalPaymentIcon.svg",
    UPI_LARGE_ICON: "https://images-static.nykaa.com/media/media/wysiwyg/Payments/UpiLargeIcon.svg",
    EMI_INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/InfoIcon.svg",
    EMI_ALERT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert.svg",
    HELP_END_ICON: "",
    EMAIL: "https://images-static.nykaa.com/media/wysiwyg/Payments/e-mail.svg",
    STREET_VIEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/StreetView1.png",
  },
  MEN: {
    AUTO_DETECT_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/AutoDetectBannerMan.svg",
    CARD_NOT_SECURED: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_alert_40x40.svg",
    UPGRADED_PAYMENT_SECURITY:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Protect_man.svg",
    CARD_NUMBER_DETAILS: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Card_Edit_40x40.svg",
    BUYERS_ASSURANCE_ICON:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Card_Lock_man.svg",
    CIRCULAR_RADIO_CHECK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/radio.svg",
    RADIO_ACTIVE: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio-List-Icon.svg",
    UPI_ACTIVE: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Radio-List-Icon.svg",
    CHECKBOX_ACTIVE: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Checkbox-Icon.svg",
    WALLET_DISCOUNT_ALERT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Wallet_Discount_Alert_Man.svg",
    ADD_ADDRESS_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/plus-man.svg",
    CVV_INFO: "https://images-static.nykaa.com/media/wysiwyg/Payments/cvv_man.svg",
    ACTION_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-icon.svg",
    HEADER_LOGO: "https://www.nykaa.com/media/wysiwyg/2018/SVGIMAGES/nykaamanlogo_2023.svg",
    HEADER_EDIT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/edit.svg",
    HEADER_TICK: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/tick.svg",
    PAYMENT_HEADER_BACKGROUND:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/payment-icon.svg",
    WALLET_DISCOUNT:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Fashion_icons/Wallet_Discount_man.svg",
    AUTH_CARD: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth1.svg",
    AUTH_CARD_SIGN_UP:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth3.svg",
    AUTH_CARD_GUEST: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth2.svg",
    PAGE_TITLE_AUTH:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/header-auth.svg",
    RADIO_ICON_SELECTED:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Man-Radio-Icon-Selected.svg",
    AUTO_DETECT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/AutoDetectMan.svg",
    DESKTOP_PAGE_TITLE_ADDRESS_IMAGE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/Fashion_icons/addressHeader.svg",
    TICK_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Toggle.svg",
    RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/arrow-right-men.svg",
    ADDRESS_BACKFRICTION_LEADING_ICON:
      "https://images-static.nykaa.com/media/desktop-icons/Vector_man.svg",
    MAPS_BACKGROUND: "https://images-static.nykaa.com/media/wysiwyg/Payments/ManStreet.png",
    PRIVACY_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Men-vendor.svg",
    DELIVERY_TRUCK: "https://images-static.nykaa.com/media/wysiwyg/Payments/DeliveryTruck.svg",
    ALERT_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/AlertWarning.svg",
    RIGHT_CHEVRON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron-right-man.svg",
    TICK_ICON_NEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/tick-man.svg",
    DETECT_LOCATION: "https://images-static.nykaa.com/media/wysiwyg/Payments/LocateIconMan.svg",
    PRIMARY_RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/RightArrowMan.svg",
    EMI_INFO_ICON: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/InfoIcon.svg",
    EMI_ALERT: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/alert.svg",
  },
  NIKE: {
    // Update after discussion with design team
    PAYMENT_HEADER_BACKGROUND: "",
    AUTO_DETECT_BANNER: "https://images-static.nykaa.com/media/wysiwyg/Payments/AutoDetectBannerFashion.svg",
    AUTH_CARD: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth1.svg",
    AUTH_CARD_SIGN_UP:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth3.svg",
    AUTH_CARD_GUEST: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/auth2.svg",
    PAGE_TITLE_AUTH:
      "https://adn-static1.nykaa.com/media/wysiwyg/Payments/desktop-icons/header-auth.svg",
      // New Updated Icons
    ALERT: "",
    ALERT_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Alert_Circle_Nike.svg",
    INFO_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Info_Circle_Nike.svg",
    ARROW_DOWN: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Down_Nike.svg",
    ARROW_LEFT: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Left_Nike.svg",
    ARROW_RIGHT: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Right_Nike.svg",
    ARROW_UP: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Up_Nike.svg",
    CHECKBOX: "https://images-static.nykaa.com/media/wysiwyg/Payments/checkbox-nike-unselected.svg",
    CREDIT_CARD: "https://images-static.nykaa.com/media/wysiwyg/Payments/CC_Nike.svg",
    UPI: "https://images-static.nykaa.com/media/wysiwyg/Payments/UPI_Nike.svg",
    COD: "https://images-static.nykaa.com/media/wysiwyg/Payments/cod_Nike.svg",
    EMI: "https://images-static.nykaa.com/media/wysiwyg/Payments/Emi_Nike.svg",
    ORDER_CONFIRMED_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Check_Circle_Nike.svg",
    CLEAR: "https://images-static.nykaa.com/media/wysiwyg/Payments/Close_Nike.svg",
    NETBANKING: "https://images-static.nykaa.com/media/wysiwyg/Payments/Nb_Nike.svg",
    DESKTOP_PAGE_TITLE_ADDRESS_IMAGE: "",
    CARD_NOT_SECURED: "",
    UPGRADED_PAYMENT_SECURITY: "",
    CARD_NUMBER_DETAILS: "",
    BUYERS_ASSURANCE_ICON: "",
    CIRCULAR_RADIO_CHECK:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/circular_radio_check_nike.svg",
    RADIO: "https://images-static.nykaa.com/media/wysiwyg/Payments/radio-nike-unselected.svg",
    RADIO_ACTIVE: "https://images-static.nykaa.com/media/wysiwyg/Payments/radio-nike-selected.svg",
    UPI_ACTIVE: "",
    CHECKBOX_ACTIVE:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/checkox_active_nike(b19995dd-96ff-4232-b56e-a934c5c1821d).svg",
    WALLET_DISCOUNT_ALERT: "",
    ADD_ADDRESS_ICON:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/plus_nike.svg",
    CVV_INFO: "",
    ACTION_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Right_Nike.svg",
    HEADER_EDIT: "https://images-static.nykaa.com/media/wysiwyg/Payments/Edit-Icon-Nike.svg",
    HEADER_TICK: "https://images-static.nykaa.com/media/wysiwyg/Payments/header-tick-nike-2.svg",
    WALLET_DISCOUNT: "https://images-static.nykaa.com/media/wysiwyg/Payments/payment-offer-nike.svg",
    RADIO_ICON_SELECTED:
      "https://images-static.nykaa.com/media/wysiwyg/Payments/radio_icon_selected_nike.svg",
    AUTO_DETECT: "https://images-static.nykaa.com/media/wysiwyg/Payments/auto_detect_nike.svg",
    TICK_ICON: "",
    RIGHT_ARROW: "https://images-static.nykaa.com/media/wysiwyg/Payments/arrow_right_nike.svg",
    TICK_ICON_NEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/tick_nike.svg",
    ADDRESS_BACKFRICTION_LEADING_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/address_backfriction_nike.svg",
    RIGHT_CHEVRON: "https://images-static.nykaa.com/media/wysiwyg/Payments/chevron_right_nike.svg",
    CLEAR_WHITE: "https://images-static.nykaa.com/media/wysiwyg/Payments/Close_Nike.svg",
    EDD_INFO_ICON: "",
    EMI_INFO_ICON: "",
    EMI_ALERT: "",
    ARROW_SOLID: "",
    DELIVERY_VAN_ICON: "",
    CONTINUE_SHOPPING_ICON: "",
    ALERT_INFO: "",
    HELP_END_ICON: "https://images-static.nykaa.com/media/wysiwyg/Payments/Caret_Right_Nike.svg",
    EMAIL: "https://images-static.nykaa.com/media/wysiwyg/Payments/email-nike.svg",
    DIAL: "https://images-static.nykaa.com/media/wysiwyg/Payments/phone-nike.svg",
    PHONE: "https://images-static.nykaa.com/media/wysiwyg/Payments/phone-nike.svg",
    CUSTOMER_SUPPORT: "https://images-static.nykaa.com/media/wysiwyg/Payments/chat-nike.svg",
    STREET_VIEW: "https://images-static.nykaa.com/media/wysiwyg/Payments/detect-address-nike.png",
    MAPS_BACKGROUND: "https://images-static.nykaa.com/media/wysiwyg/Payments/detect-address-nike.png",
    PRIVACY_ICON: "",
    FAIL_ICON: "",
  },
};
/**
 * if ICON is common in all platform then pass empty string
 * in platform
 */
export const getIcons = (platform: string, iconName: string) => {
  let icon = ALL_ICONS.NYKAA[iconName];
  switch (platform) {
    case platformNames.FASHION:
      if (ALL_ICONS.FASHION[iconName]) {
        icon = ALL_ICONS.FASHION[iconName];
      }

      break;
    case platformNames.FOOTLOCKER:
      if (ALL_ICONS.FOOTLOCKER[iconName]) {
        icon = ALL_ICONS.FOOTLOCKER[iconName];
      }

      break;
    case platformNames.MEN:
      if (ALL_ICONS.MEN[iconName]) {
        icon = ALL_ICONS.MEN[iconName];
      }

      break;
    case platformNames.NIKE:
      if (iconName in ALL_ICONS.NIKE) {
        icon = ALL_ICONS.NIKE[iconName];
      }
      break;
    default:
      return ALL_ICONS.NYKAA[iconName];
  }
  return icon || "";
};

export const getEndIconforPaymentMethod = (deviceType: string, isAccordianOpened: boolean) => {
  const platform = __PLATFORM__;
  let Icon = "";
  if (deviceType === DEVICE_TYPE.DESKTOP) {
    Icon = isAccordianOpened
      ? getIcons(platform, ICONS_NAMES.RADIO_ACTIVE)
      : getIcons(platform, ICONS_NAMES.RADIO);
  } else {
    Icon = isAccordianOpened
      ? getIcons(platform, ICONS_NAMES.ARROW_UP)
      : getIcons(platform, ICONS_NAMES.ARROW_DOWN);
  }
  return Icon;
};

/**
 * @description -- function to get the icon url
 * @param isSelected -- whether shown payment option is selected or not
 * @returns iconUrl - string
 */
export const getEndIconForPaymentFailure = (isSelected: boolean) => {
  const platform = __PLATFORM__;
  let Icon = isSelected
    ? getIcons(platform, ICONS_NAMES.RADIO_ICON_SELECTED)
    : getIcons(platform, ICONS_NAMES.RADIO);
  return Icon;
};
